import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "font-awesome/css/font-awesome.css";
import { getApprovalLogs } from "@/api/table";
import {
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Pagination,
  Select,
  Option,
  Input,
  Tooltip,
  Row,
  Col,
  DatePicker,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Dialog,
  Form,
  FormItem,
  Divider,
  Link,
  Message,
  MessageBox,
  InputNumber,
  Tag,
  Switch,
  Breadcrumb,
  BreadcrumbItem,
  Descriptions,
  DescriptionsItem,
  Radio,
  Steps,
  Step,
  Tree,
  Checkbox,
  Cascader,
  Menu,
  MenuItem,
  Submenu,
  Alert,
  CheckboxGroup,
  Upload,
  RadioGroup,
  Popover,
  Empty,
  Loading,
  TimeSelect,
  TimePicker,
  Progress,
  Autocomplete,
} from "element-ui";

import "@/icons";
import "@/components/ef/index.css";
import "../src/assets/css/ionicons.min.css";

import Vue2Editor from "vue2-editor";

import MyBreadcrumb from "@/components/breadcrumb/breadcrumb.vue";
import ScreenSearchBox from "@/components/screenSearchBox/screenSearchBox.vue";

 
import { getAllData } from "@/utils/getAllDate";
import Vue2OrgTree from "vue2-org-tree";
import i18n from "@/lang";
import "@/assets/css/common.css";
import Print from "vue-print-nb";
import "./permission";
import filters from "@/utils/filters";

for (let key in filters) {
  Vue.filter(key, filters[key]);
}

Vue.config.productionTip = false;

import xiaobu from "vue2-water-marker";
import { monthList } from "@/utils/optionsData";
Vue.use(xiaobu);
Vue.use(Table)
  .use(TableColumn)
  .use(Tabs)
  .use(TabPane)
  .use(Pagination)
  .use(Select)
  .use(Option)
  .use(Input)
  .use(Tooltip)
  .use(Row)
  .use(Col)
  .use(DatePicker)
  .use(Drawer)
  .use(Dropdown)
  .use(DropdownItem)
  .use(DropdownMenu)
  .use(Button)
  .use(Dialog)
  .use(Form)
  .use(FormItem)
  .use(Divider)
  .use(Link)
  .use(InputNumber)
  .use(Tag)
  .use(Switch)
  .use(Breadcrumb)
  .use(BreadcrumbItem)
  .use(Descriptions)
  .use(DescriptionsItem)
  .use(Radio)
  .use(Steps)
  .use(Step)
  .use(Tree)
  .use(Checkbox)
  .use(Cascader)
  .use(Menu)
  .use(MenuItem)
  .use(Submenu)
  .use(Alert)
  .use(CheckboxGroup)
  .use(Upload)
  .use(RadioGroup)
  .use(Popover)
  .use(Empty)
  .use(Loading.directive)
  .use(TimeSelect)
  .use(TimePicker)
  .use(Progress)
  .use(Autocomplete);

Vue.use(Print);
Vue.use(Vue2Editor);
Vue.use(Vue2OrgTree);

//全局注册面包屑导航
Vue.component("Breadcrumb", MyBreadcrumb);

//全局注册筛选收纳
Vue.component("ScreenSearchBox", ScreenSearchBox);

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$copy = function copyToClipboard(text) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
  Message.success("复制成功");
};

Vue.prototype.$getAllData = getAllData;

Vue.prototype.$Logs = function getLogs(data) {
  getApprovalLogs(data).then((res) => {
    if (res.status === 200) {
      this.$store.commit("changeApprovalLogsVisible", true);
      const AuditLogs = res.response ? res.response.AuditLogs : [];
      const AuditStatusDic = res.response ? res.response.AuditStatusDic : [];
      const WorkFlowSteps = res.response ? res.response.Steps : [];

      this.$store.commit("changeApprovalLogsTableData", AuditLogs);
      this.$store.commit("changeAuditStatusDic", AuditStatusDic);
      this.$store.commit("changeWorkFlowSteps", WorkFlowSteps);
    }
  });
};

Vue.prototype.$monthList = monthList;
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
